import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';

declare global {
  interface HjFunction {
    (...args: unknown[]): void;
    q?: unknown[][];
  }

  interface Window {
    hj?: HjFunction;
    _hjSettings?: {
      hjid: number;
      hjsv: number;
    };
    hjInitialized?: boolean;
  }
}

@Injectable({
  providedIn: 'root'
})
export class HotjarService {

  init(nameSpaceName: string): void {
    if (!environment.hotjarSiteId) return;

    (function (
      h: Window,
      o: Document,
      t: string,
      j: string
    ): void {
      const hjFunc: HjFunction = h.hj || function (...args: unknown[]) {
        (hjFunc.q = hjFunc.q || []).push(args);
      };

      h.hj = hjFunc;

      h._hjSettings = {
        hjid: environment.hotjarSiteId,
        hjsv: 6
      };

      const head = o.getElementsByTagName('head')[0];
      const script = o.createElement('script');
      script.async = true;
      script.src = `${t}${h._hjSettings.hjid}${j}${h._hjSettings.hjsv}`;
      head.appendChild(script);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');

    window.hjInitialized = true;
    this.markUserByNamespace(nameSpaceName);
  }

  private markUserByNamespace(nameSpaceName: string): void {
    const interval = setInterval(() => {
      if (typeof window.hj === 'function') {
        window.hj('tagRecording', [`namespace:${nameSpaceName}`]);
        window.hj('identify', nameSpaceName, {
          namespace: nameSpaceName
        });
        clearInterval(interval);
      }
    }, 300);
  }

}
